import React, { useState } from 'react'
import { Grid, TextField, Dialog, DialogTitle, Button, CircularProgress, IconButton, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { Close } from '@material-ui/icons';
import { createUser } from '../../services/users/createUser';

const useStyles = makeStyles(() => ({
  dialog: {
    height: 'auto',
    width: '40%',
    padding: '2%',
    margin: 'auto'
  },
}));

const NewUserDialog = ({ open, handleClose }) => {
  const classes = useStyles();
  const [name, setName] = useState('')
  const [lastname, setLastname] = useState('')
  const [mail, setMail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(prevState => !prevState)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClick = async () => {
    setLoading(true)
    if (name && mail && password) {
      if (name.match(/^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g) && lastname.match(/^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g) && mail.match(/^[ A-Za-z0-9_.-]*$/)){
        const newUser = {
          name: `${name} ${lastname}`,
          email: `${mail.toLowerCase()}@entelai.com`,
          password: password,
        }
        try {
          const response = await createUser(newUser)
          alert(`El usuario ${response.email} ha sido creado con éxito.`)
          setLoading(false)
          window.location.reload()
        } catch (error) {
          alert('Hubo un problema al crear el usuario.')
          setLoading(false)
        }
      } else {
        alert('No estan permitidos los caracteres especiales.')
        setLoading(false)
      }
    } else {
      alert('Todos los datos son obligatorios')
      setLoading(false)
    }
  };

  return (
    <Dialog
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        maxWidth="lg"
        classes={{
          paperWidthLg: classes.dialog, // class name, e.g. `classes-nesting-root-x`
        }}
      >
        <DialogTitle>
          Crear Usuario
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            style={{left: '70%'}}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Grid container>
          <Grid item xs={6}>
            <TextField name="name" label="Nombre" variant="outlined" fullWidth autoComplete='off' value={name} onChange={({target}) => setName(target.value)}/>
          </Grid>
          <Grid item xs={6}>
            <TextField name="lastname" label="Apellido" variant="outlined" fullWidth autoComplete='off' value={lastname} onChange={({target}) => setLastname(target.value)}/>
          </Grid>
          <Grid item xs={12}>
            <TextField name="mail" label="Mail" variant="outlined" fullWidth style={{marginTop: '12px'}} autoComplete='off' value={mail} onChange={({target}) => setMail(target.value)} InputProps={{endAdornment: <InputAdornment position="end">@entelai.com</InputAdornment>,}}/>
          </Grid>
          <Grid item xs={12}>
            <TextField 
              name="password"
              label="Contraseña"
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              style={{marginTop: '12px'}}
              value={password}
              onChange={({target}) => setPassword(target.value)}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {loading && <CircularProgress style={{marginTop: '12px', marginRight: '5%', float: 'right'}}/>}
            {!loading && <Button variant="contained" color="primary" style={{marginTop: '12px', float: 'right'}} onClick={() => handleClick()}>
              CREAR USUARIO
            </Button>}
          </Grid>
        </Grid>
      </Dialog>
  )
}

export default NewUserDialog
